/* eslint-disable react/no-danger */
import React from "react";
import { v4 as uuidv4 } from "uuid";

import { useAppState } from "hooks/AppContext";
import { getJobTrackingProps } from "utils/tracking";
import { JobApplyButton } from "./JobApplyButton";
import { JWPlayerVideoModule } from "./JWPlayerVideoModule";
import { PerksAndBenefits } from "./PerksAndBenefits";
import { JobClientProvidedLocation } from "./JobClientProvidedLocation";
import { JobAlert } from "./JobAlert";

import styles from "./JobIndividualBody.module.scss";

export const JobIndividualBody = (props: { setIsOpen: (x: boolean) => void, isDirectApply: boolean }) => {
    const { job, company } = useAppState();
    const { setIsOpen, isDirectApply } = props;

    const trackApplyProps = {
        ...getJobTrackingProps(job, company),
        placement_position: "desktop_bottom"
    };

    return (
        <section className={styles.jobBodyContainer}>
            <article className={styles.jobBodyDescription}>
                {job?.compiled_contents.map((x: string, index: number) => (
                    <React.Fragment key={uuidv4()}>
                        <div key={uuidv4()} dangerouslySetInnerHTML={{ __html: x }} />
                        {/* Always after the first block, even if there is only one. */}
                        {!isDirectApply && index === 0 ? <JobAlert job={job} company={company} /> : null}
                    </React.Fragment>
                ))}
            </article>
            <div className={styles.applyContainer}>
                {job?.state === "live"
                    ? (
                        <JobApplyButton
                            className={styles.applyButton}
                            jobId={job?.id}
                            setIsOpen={setIsOpen}
                            isDirectApply={isDirectApply}
                            trackingProps={trackApplyProps}
                        />
                    )
                    : null}
            </div>
            <div className={styles.jobBodyFooter}>
                <JobClientProvidedLocation locations={job?.locations} />
                Job ID: {job?.ats_info?.id}
            </div>
            { job.has_jwp_hiring_manager_playlist ? (
                <JWPlayerVideoModule
                    title="Meet the Hiring Manager"
                    description="Hear directly from the hiring manager about what it is like to work here."
                    tagName={job?.id}
                />
            ) : null }
            <PerksAndBenefits company={company} />
            { company.has_jwp_company_playlist ? (
                <JWPlayerVideoModule
                    title="Company Videos"
                    description={`Hear directly from employees about what it is like to work at ${company.name}.`}
                    tagName={`${company?.name},final`}
                />
            ) : null }
        </section>
    );
};
